// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kQ-z","twoColumnImage":"lQ-z"};